function execGoogleRecaptcha($fields, pubKey) {
  // eslint-disable-next-line no-undef
  grecaptcha.ready(() => {
    // eslint-disable-next-line no-undef
    grecaptcha.execute(pubKey, {}).then((token) => {
      $fields.val(token);
      setTimeout(() => {
        // execute reCaptcha every minute to prevent timeouts
        execGoogleRecaptcha($fields, pubKey);
      }, 60 * 1000);
    });
  });
}

window.Foundation.registerExtension(($elem) => {
  const $fields = $elem.find('[data-recaptcha]');
  if ($fields.length > 0) {
    const pubKey = $fields.first().attr('data-recaptcha');

    if (typeof grecaptcha === 'undefined') {
      // Load Google Recaptcha Library
      $.ajax({
        url: `https://www.google.com/recaptcha/api.js?render=${pubKey}`,
        dataType: 'script',
        cache: true,
      }).done(() => {
        execGoogleRecaptcha($fields, pubKey);
      });
    } else {
      execGoogleRecaptcha($fields, pubKey);
    }
  }
});
